import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "cn";
import type { FC, ReactNode } from "react";
import React from "react";

import type { VariantProps } from "@react/ui-primitives/lib";

const variants = cva("", {
  defaultVariants: { active: false },
  variants: {
    active: {
      false: `
        text-[color-mix(in_srgb,var(--header-foreground)_70%,transparent)]
        hover:bg-[color-mix(in_srgb,var(--header-accent)_50%,transparent)] hover:text-header-foreground
      `,
      true: `
        bg-header-accent text-header-foreground
        after:absolute after:bottom-0 after:left-1/2 after:h-0.5 after:w-4 after:-translate-x-1/2 after:rounded-full after:bg-primary after:content-['']
      `,
    },
  },
});

interface AppNavButtonProps extends VariantProps<typeof variants> {
  readonly asChild?: boolean;
  readonly children: ReactNode;
}

export const AppNavButton: FC<AppNavButtonProps> = ({
  active,
  asChild,
  children,
}) => {
  const Comp = asChild === true ? Slot : "button";

  return (
    <Comp
      className={cn(
        "relative flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium no-underline transition-all duration-150",
        variants({ active }),
      )}
    >
      {children}
    </Comp>
  );
};
